export const SITE = {
  name: "Babblebots.ai",
  domain: "https://babblebots.ai",
  description:
    "We fast-track your hiring by sourcing, interviewing and curating the best candidates, so you can focus on the business.",
  twitter: "@babblebots_ai",
  ogDefault: "https://babblebots.ai/default-og.jpg",
  logo: "https://babblebots.ai/logominor.png",
};

